import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const DEFAULT_WORDS = ["Join", "Create", "Make", "Enjoy"];
const TYPE_SPEED = 120; // мс между появлением букв
const ERASE_SPEED = 80; // мс между удалением букв
const PAUSE = 1000; // пауза, когда слово полностью напечатано

function Typewriter({ isMobile, wordsKey = "section1.hero.typewriter_words" }) {
  const { t } = useTranslation();

  // Массив слов из словаря (для EN/RU и др.)
  const translatedWords = t(wordsKey, {
    returnObjects: true,
  });

  const wordsFromDict = Array.isArray(translatedWords)
    ? translatedWords
    : [];
  const wordsSignature = wordsFromDict.join("|");

  const WORDS =
    wordsFromDict.length > 0 ? wordsFromDict : DEFAULT_WORDS;

  const [wordIndex, setWordIndex] = useState(0); // индекс текущего слова
  const [length, setLength] = useState(0); // сколько букв показываем
  const [phase, setPhase] = useState("type"); // "type" | "erase" | "pause"

  // Если список слов поменялся (например, сменили язык) —
  // сбрасываем анимацию, чтобы первое слово печаталось с нуля,
  // а не с длины предыдущего варианта.
  useEffect(() => {
    setWordIndex(0);
    setLength(0);
    setPhase("type");
  }, [wordsSignature]);

  useEffect(() => {
    if (!WORDS.length) return;

    let timer;
    const currentWord = WORDS[wordIndex];

    if (phase === "type") {
      if (length < currentWord.length) {
        timer = setTimeout(
          () => setLength((prev) => prev + 1),
          TYPE_SPEED
        );
      } else {
        // допечатали слово — делаем паузу
        timer = setTimeout(() => setPhase("pause"), PAUSE);
      }
    } else if (phase === "erase") {
      if (length > 0) {
        timer = setTimeout(
          () => setLength((prev) => prev - 1),
          ERASE_SPEED
        );
      } else {
        // полностью стерли — переключаемся на следующее слово
        timer = setTimeout(() => {
          setWordIndex((prev) => (prev + 1) % WORDS.length);
          setPhase("type");
        }, TYPE_SPEED);
      }
    } else if (phase === "pause") {
      // после паузы начинаем стирать
      timer = setTimeout(() => setPhase("erase"), PAUSE);
    }

    return () => clearTimeout(timer);
  }, [length, phase, wordIndex, WORDS]);

  const visible =
    WORDS.length > 0 ? WORDS[wordIndex].slice(0, length) : "";

  return (
    <span className="whitespace-nowrap">
      {visible}
      {/* мигающий курсор */}
      <span
        className={
          "inline-block h-[1em] bg-white animate-caret relative " +
          (isMobile
            ? "w-[2px] left-[1px] top-[5px]" // мобильная версия
            : "w-[5px] left-[2px] top-[18px]") // десктопная версия
        }
      />
    </span>
  );
}

export default Typewriter;
